(function () {
  function openItem(items, item, scroll, root) {
    for (var i = 0; i < items.length; i++) {
      var current = items[i];
      var isTarget = current === item;
      var trigger = current.querySelector('[data-faq-trigger]');
      var panel = current.querySelector('[data-faq-panel]');
      current.classList.toggle('is-open', isTarget);
      if (trigger) trigger.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      if (panel) panel.hidden = !isTarget;
    }
    if (root) {
      var navLinks = root.querySelectorAll('[data-faq-nav]');
      for (var n = 0; n < navLinks.length; n++) {
        var link = navLinks[n];
        var href = link.getAttribute('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : href;
        link.classList.toggle('is-active', item && item.id === id);
      }
    }
    if (scroll && item) {
      var top = item.getBoundingClientRect().top + window.pageYOffset - 88;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function initSection(root) {
    var items = root.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    var navLinks = root.querySelectorAll('[data-faq-nav]');

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var trigger = item.querySelector('[data-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            var panel = item.querySelector('[data-faq-panel]');
            if (panel) panel.hidden = true;
            openItem(items, null, false, root);
          } else {
            openItem(items, item, false, root);
          }
        });
      })(items[i]);
    }

    for (var j = 0; j < navLinks.length; j++) {
      navLinks[j].addEventListener('click', function (e) {
        e.preventDefault();
        var href = this.getAttribute('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : href;
        var target = root.querySelector('#' + id);
        if (target) openItem(items, target, true, root);
      });
    }

    openItem(items, items[0], false, root);
  }

  function init() {
    var sections = document.querySelectorAll('.lb-faq-premium');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
